import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "col-12 row g-0" }
const _hoisted_2 = { class: "form-group col-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "equipment-name" }, " Equipment Name ", -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  class: "text-end col-6"
}
const _hoisted_5 = { class: "col-12 row g-0 border-bottom" }
const _hoisted_6 = { class: "form-group col-12 col-lg-4 pe-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "provider-name" }, " Provider Name ", -1 /* HOISTED */)
const _hoisted_8 = { class: "form-group col-12 col-lg-4 px-lg-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "model-no" }, " Model No. ", -1 /* HOISTED */)
const _hoisted_10 = { class: "form-group col-12 col-lg-4 px-lg-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "serial-no" }, " Serial No. ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_TypeaheadInput, {
          placeholder: "Start Typing",
          getData: _ctx.getDmesList,
          value: _ctx.dmeData,
          onValueChanged: _ctx.changeDmeData
        }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"])
      ]),
      (_ctx.dmeIndex != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("i", {
              class: "fa fa-times fa-2x text-danger p-3",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeEquipment(_ctx.dmeIndex)))
            })
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dmeNeeded.provider) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.dmeNeeded.provider]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dmeNeeded.modelNo) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.dmeNeeded.modelNo]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dmeNeeded.serialNo) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.dmeNeeded.serialNo]
        ])
      ])
    ])
  ]))
}